import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, vShow as _vShow, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gifs/Aguarde.gif'


const _withScopeId = n => (_pushScopeId("data-v-427639be"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = {
  class: "modal-title",
  id: "staticBackdropLabel"
}
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "containerPrincipal p-0" }
const _hoisted_7 = { class: "form-label col-12" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "C" }, "Contém", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "I" }, "Inicia", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "T" }, "Termina", -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "col-12 col-md-12 col-lg-2 pe-2 colunaCampoPesquisa"
}
const _hoisted_13 = { class: "form-label col-12" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "form-label col-12" }
const _hoisted_17 = { class: "input-group" }
const _hoisted_18 = ["onKeyup"]
const _hoisted_19 = {
  key: 0,
  class: "w-100 d-flex justify-content-center align-items-center"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  srcset: "",
  height: "50",
  width: "50"
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  class: "table mb-0 table-bordered table-striped",
  style: { 'maxHeight': '25px' }
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col-3" }, null, -1))
const _hoisted_30 = { class: "col-sm-1 col-md-1 py-0 pt-1 text-center" }
const _hoisted_31 = {
  key: 0,
  class: "col-sm-7 col-md-7 pt-1 text"
}
const _hoisted_32 = {
  key: 1,
  class: "col-sm-7 col-md-7 py-0 pt-1"
}
const _hoisted_33 = {
  key: 0,
  class: "ri-star-fill favorito"
}
const _hoisted_34 = { class: "col-sm-1 col-md-1 py-0 pt-1 tdBtn" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "col-sm-3 col-md-3 tdBtn" }
const _hoisted_37 = ["onClick", "disabled"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_40 = {
  class: "modal-backdrop fade show",
  id: "backdrop"
}

import { onMounted, reactive } from 'vue';
import ModalMensagemDorape from './ModalMensagemDorape.vue';
import { TipoMensagem } from '@/consts/consts';
import mensagem from '@/hooks/mensagem';
import services from '@/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalPesqDorape',
  props: ["id", "title", "tabela", "favorito", "dependencia", "SQL", "condiction", 'hqlIdCliente',
    "tabelaPorId", "campoPorId", "listar", "nome", "codigo", "height", "width", "visiblePesq", "data", "colunas",
    "linhas", "pesquisaTabela", "campoSelecionado", "labelCampoSelecionada", "cadastroPadrao", "distinct", "tabelasJoin"],
  emits: ["modalResult"],
  setup(__props, { emit }) {

const props = __props;




const state = reactive({
    lst: [{} as any],
    ordenacao: ["", "asc", "desc"],
    arrow: [Number(), Number()],

    objeto: props.data,

    visivel: Boolean(false),
    temErro: Boolean(),
    carregando: Boolean(true),
    usarSQL: Boolean(props.SQL),
    usarFavorito: props.favorito,
    primeiroFavorito: props.favorito,

    pesquisa: String(""),//Fabio
    tipoPesq: "C",
    sql: String(),
    tituloErro: "Erro",
    erro: String(),
    tabela: props.tabela,
    // campoPesq: String(),
    campoPesq: props.nome,

    ordenarAux: Number(),
    ordenarNumAnterior: Number(),
    timer: Number(),

    campoSelecionado: String(),
    textoAuxiliar: String("Digite algo para pesquisar")
});

function debouche() {
    clearTimeout(state.timer);
    state.timer = setTimeout(function () {
        pesquisar();
    }, 500);
}

// function bloquearScroll() {
//     setInterval(() => {(props.visiblePesq) ? document.querySelector("html")?.classList.add("overflow-hidden") : "";}, 100);
// }

onMounted(async () => {
    if (props.labelCampoSelecionada?.trim() === "") {
        (props.linhas.includes("nome")) ? state.campoSelecionado = "nome" : state.campoSelecionado = "descricao";
    } else {
        state.campoSelecionado = props.campoSelecionado;
    }
    state.lst.pop();
    state.visivel = props.visiblePesq;
    (props.SQL != 'true') ? modalPesq(state.primeiroFavorito) : pesquisar();

    // bloquearScroll();
    // setInterval(() => {
    // console.log(state.visivel);
    // (state.visivel) ?
    document.querySelector("html")?.classList.add("overflow-hidden");
    // :
    // document.querySelector("html")?.classList.remove("overflow-hidden");
    // "";
    // }, 100);
    // document.querySelector("html")?.classList.add("overflow-hidden");

    // console.log(Object.keys(state.objeto));
    // (Object.keys(state.objeto).includes('nome')) ? state.campoPesq = "Nome" : state.campoPesq = "Descricao";
    document.getElementById("EdPesquisa")?.focus();
    state.carregando = false;
});

function cancelar() {
    state.visivel = false;
    document.querySelector("html")?.classList.remove("overflow-hidden");
    emit("modalResult", "cancel", props.codigo);
}

function confirmar(obj: Record<string, unknown>) {
    state.visivel = false;
    document.querySelector("html")?.classList.remove("overflow-hidden");
    emit("modalResult", "ok", obj);
}

function atualizarDados(favorito: boolean) {
    (props.SQL != 'true') ? modalPesq(favorito) : pesquisarSQL("", favorito);
}

async function modalPesq(favorito: boolean) {
    state.lst = Array<object>();
    if (state.lst.length === 1) {
        let condicional = (props.listar.indexOf("?") != -1);
        let exibirFavorito = "";
        if (favorito) {
            (condicional) ? exibirFavorito = `&favoritos=${favorito}` : exibirFavorito = `?favoritos=${favorito}`;
        }
        await services.dinamico.getDinamico(`${state.tabela}${props.listar}${exibirFavorito}`)
            .then(resposta => {
                state.carregando = true;
                state.lst.pop();
                resposta.data.forEach((resp: Record<string, unknown>) => {
                    var obj = {
                        id: resp[props.codigo.toLowerCase()],
                        descricao: resp[props.nome.toLowerCase()],
                        ativo: resp['ativo'] || resp[2],
                        favorito: resp['favorito'] || resp[3]
                    };
                    state.lst.push(obj);
                });
            });
        state.carregando = false;
    }
}

async function favoritar(pId: number, pFavorito: boolean) {
    state.lst = state.lst.map((a: any) => {
        (a['id'] === pId) ? a['favorito'] = pFavorito : "";
        return a;
    });
    await services.dinamico.postDinamicoLink(`${props.tabela}/favoritar?pId=${pId}&pFavorito=${pFavorito}`);
}

async function selecionar(pId: number) {
    // state.visivel = false;
    const msg = mensagem();
    const { data, erros } = await services.dinamico.getDinamico(`${props.tabelaPorId}/${props.campoPorId}=${pId}`);
    state.objeto = data;
    (!erros) ?
        confirmar(state.objeto)
        :
        msg.InserirMensagem('Erro', erros.statusText, TipoMensagem.Error);
}

async function modalPesquisarTexto(pHql: string) {
    state.lst = Array<object>();
    state.carregando = true;
    await services.relatorio.ListarHql(pHql)
        .then((resposta) => {
            const someArray = resposta.data;
            someArray.forEach((vetor: Record<string, unknown>) => {
                var obj = {
                    id: vetor[0],
                    descricao: vetor[1],
                    ativo: vetor[2] || true,
                    favorito: vetor[3]
                };
                state.lst.push(obj);
            });
        });
    state.carregando = false;
}

function pesquisar() {
    let campoId = props.codigo;
    let campoOrderBy = state.campoPesq;
    let tabela = props.tabela;
    let fetchjoin = props.dependencia || "";
    let likeSQL = "";
    state.carregando = true;

    state.sql = "select ";

    if (props.distinct)
        state.sql += "distinct";

    state.sql += " t." + campoId + " , t." + state.campoPesq + " , t.Ativo";

    if (Object.keys(state.objeto).includes('favorito')) {
        state.sql += ", t.Favorito";
    }

    state.sql += " from " + tabela + " t ";

    if (props.tabelasJoin) {
        state.sql += ` RIGHT JOIN ${props.tabelasJoin} ${props.tabelasJoin[0]}${props.tabelasJoin[1]}${props.tabelasJoin[2]} ON T.ID = ${props.tabelasJoin[0]}${props.tabelasJoin[1]}${props.tabelasJoin[2]}.ID_PACIENTE `;
    }

    state.sql += fetchjoin + " where ";

    Object.keys(state.objeto).forEach((c: string) => {
        // if (c.toUpperCase() === ("IDCLIENTE")) {
        //     state.sql += " t.IdCliente = :IdCliente and ";
        // }

        // if (c.toUpperCase() === ("ATIVO")) {
        //     state.sql += " t.Ativo = 'true' and ";
        // }
    });


    if (props.condiction != undefined) {
        state.sql += props.condiction + " and ";
    }

    switch (state.tipoPesq) {
        case "C": {
            likeSQL += "upper(t." + state.campoSelecionado + ") like upper('%" + state.pesquisa + "%')";
            break;
        }
        case "I": {
            likeSQL += "upper(t." + state.campoSelecionado + ") like upper('" + state.pesquisa + "%')";
            break;
        }
        case "T": {
            likeSQL += "upper(t." + state.campoSelecionado + ") like upper('%" + state.pesquisa + "')";
            break;
        }
    }

    state.sql += likeSQL;
    // if (props.SQL == 'false') {
    //     modalPesquisarTexto(state.sql);
    // } else {
    //     pesquisarSQL(state.sql, true);
    // }
    (props.SQL == 'false') ? modalPesquisarTexto(state.sql) : pesquisarSQL(state.sql, true);
}

async function pesquisarSQL(where: string, favorito: boolean) {
    let param = "";
    if (favorito) {
        param = "&orderBy= 4 desc,1";
    }
    // console.log(state.sql);

    if (state.pesquisa.trim().length > 0) {
        const { data, erros } = await services.relatorio.ListarSql(state.sql);
        if (!erros) {
            state.lst = [];
            // console.log(data);
            if (data.length >= 1) {
                data.forEach((d: any, index: number) => {
                    let obj = {
                        id: d[0],
                        descricao: d[1],
                        ativo: d[2],
                        favorito: d[3]
                    };
                    state.lst.push(obj);
                });
            } else if (data.length < 1) {
                state.textoAuxiliar = "Nenhum resultado Encontrado";
            }
        } else {
            const msg = mensagem();
            msg.InserirMensagem("Erro", "Erro", TipoMensagem.Error);
        }
    } else {
        state.lst = [];
        state.textoAuxiliar = "Digite algum texto para pesquisar";
    }

    // data.forEach((d: any) => {
    //     state.lst.push({ id: d[0], nome: d[1], ativo: d[2], favorito: d[3] });
    // });
    state.carregando = false;
}

function modalErroResult() {
    state.erro = "";
    state.temErro = false;
    document.querySelector("html")?.classList.remove("overflow-hidden");
}

async function ordenar(param: string, numero: number) {
    let url = "";
    state.carregando = true;
    (state.ordenarAux == 2) ? state.ordenarAux = 0 : state.ordenarAux++;

    state.arrow[numero] = state.ordenarAux;

    (state.arrow[numero] != 0) ?
        // if (props.SQL == 'false') {
        // url = `/Relatorio/relatorio?hql=select t.${props.codigo}, t.${props.nome}, t.Ativo, t.Favorito from ${props.tabela} t where t.${props.nome} like '%${state.pesquisa}%' order by t.${param} ${state.ordenacao[state.ordenarAux]}`;
        url = `/Relatorio/relatorioSQL?sql=select t.${props.codigo}, t.${props.nome}, t.Ativo from ${props.tabela} t where t.${props.nome} like '%${state.pesquisa}%' order by t.${param} ${state.ordenacao[state.ordenarAux]}`
        // }
        // else {
        //     url = `/${props.tabela}${props.listar}?where= t.${props.nome} like '%${state.pesquisa}%' order by t.${param} ${state.ordenacao[state.ordenarAux]}`;

        // }
        :
        url = `/Relatorio/relatorioSQL?sql=select t.${props.codigo}, t.${props.nome}, t.Ativo from ${props.tabela} t where t.${props.nome} like '%${state.pesquisa}%'`;

    const { data } = await services.dinamico.getDinamico(url);
    state.lst = [];
    data.forEach((d: any) => {
        state.lst.push({ id: d[0], nome: d[1], ativo: d[2], favorito: d[3] });
    });
    state.ordenarNumAnterior = numero;
    state.carregando = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.visiblePesq === true)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal fade show",
          id: __props.id,
          "data-bs-backdrop": "static",
          "data-bs-keyboard": "false",
          tabindex: "-1",
          "aria-labelledby": "staticBackdropLabel",
          "aria-modal": "true",
          style: {"display":"block"}
        }, [
          _createElementVNode("div", {
            class: "modal-dialog modal-dialog-centered",
            style: _normalizeStyle({ 'minWidth': __props.width })
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "header"),
                _createElementVNode("h5", _hoisted_4, "Pesquisa de " + _toDisplayString(__props.title), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (cancelar()))
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["col-12 col-md-12 pe-2 colunaModoPesquisa", { 'col-lg-2': __props.pesquisaTabela == true, 'col-lg-3': __props.pesquisaTabela != true }])
                  }, [
                    _createElementVNode("label", _hoisted_7, [
                      _createTextVNode("Modo de pesquisa "),
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("select", {
                          id: "SelectPesquisa",
                          class: "form-select",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.tipoPesq) = $event))
                        }, _hoisted_11, 512), [
                          [_vModelSelect, state.tipoPesq]
                        ])
                      ])
                    ])
                  ], 2),
                  (__props.pesquisaTabela)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("label", _hoisted_13, [
                          _createTextVNode("Campo da Pesquisa "),
                          (__props.pesquisaTabela)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _withDirectives(_createElementVNode("select", {
                                  id: "SelectPesquisacAMPO",
                                  class: "form-select",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.campoSelecionado) = $event)),
                                  onChange: _cache[3] || (_cache[3] = ($event: any) => (debouche()))
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.colunas, (c, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: index,
                                      value: __props.linhas[index]
                                    }, _toDisplayString(c), 9, _hoisted_15))
                                  }), 128))
                                ], 544), [
                                  [_vModelSelect, state.campoSelecionado]
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(["colunaItemPesquisa", { 'col-8 col-md-8': __props.pesquisaTabela == true, 'col-9 col-md-9': __props.pesquisaTabela != true }])
                  }, [
                    _createElementVNode("label", _hoisted_16, [
                      _createTextVNode("Digite um trecho a ser pesquisado "),
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "EdPesquisa",
                          class: "form-control caixaAlta",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.pesquisa) = $event)),
                          onInput: _cache[5] || (_cache[5] = ($event: any) => (debouche())),
                          onKeyup: [
                            _withKeys(pesquisar, ["enter"]),
                            _cache[6] || (_cache[6] = _withKeys(($event: any) => (cancelar()), ["esc"]))
                          ]
                        }, null, 40, _hoisted_18), [
                          [_vModelText, state.pesquisa]
                        ])
                      ])
                    ])
                  ], 2)
                ]),
                (state.carregando == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", {
                  class: "row px-2 scrollspy-example itensSelecionaveis",
                  style: _normalizeStyle({ 'minHeight': __props.height })
                }, [
                  _createElementVNode("table", _hoisted_22, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", {
                          class: "text-center pointer",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (ordenar(__props.codigo, 0)))
                        }, [
                          _createTextVNode(_toDisplayString(__props.codigo) + " ", 1),
                          (state.arrow[0] === 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, " ▲"))
                            : (state.arrow[0] === 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, " ▼"))
                              : (state.arrow[0] === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("th", {
                          class: "pointer",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (ordenar(__props.nome, 1)))
                        }, [
                          _createTextVNode(_toDisplayString(__props.nome) + " ", 1),
                          (state.arrow[1] === 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, " ▲"))
                            : (state.arrow[1] === 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, " ▼"))
                              : (state.arrow[1] === 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                                : _createCommentVNode("", true)
                        ]),
                        _hoisted_29
                      ])
                    ]),
                    _withDirectives(_createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.lst, (e) => {
                        return _withDirectives((_openBlock(), _createElementBlock("tr", {
                          key: e.id
                        }, [
                          _createElementVNode("td", _hoisted_30, [
                            _createElementVNode("span", {
                              class: _normalizeClass({ 'texto-inativo': e.ativo == false })
                            }, _toDisplayString(e.id), 3)
                          ]),
                          (e.descricao)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_31, [
                                _createElementVNode("span", {
                                  class: _normalizeClass({ 'texto-inativo': e.ativo == false })
                                }, _toDisplayString(e?.descricao), 3)
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_32, [
                                _createTextVNode(_toDisplayString(e?.nome) + " ", 1),
                                ((e['favorito'] == true) && (state.usarFavorito))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_33))
                                  : _createCommentVNode("", true)
                              ])),
                          _withDirectives(_createElementVNode("td", _hoisted_34, [
                            _createElementVNode("button", {
                              class: "btn btnSelecionar",
                              onClick: ($event: any) => (favoritar(e.id, !e['favorito']))
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["favorito", { 'ri-star-fill': e['favorito'] === true, 'uil-star': e['favorito'] != true }])
                              }, null, 2)
                            ], 8, _hoisted_35)
                          ], 512), [
                            [_vShow, state.usarFavorito]
                          ]),
                          _createElementVNode("td", _hoisted_36, [
                            _createElementVNode("button", {
                              class: "btn btn-info btnSelecionar w-100",
                              onClick: ($event: any) => (selecionar(e.id)),
                              disabled: e.ativo == false
                            }, " Selecionar ", 8, _hoisted_37)
                          ])
                        ])), [
                          [_vShow, (e?.ativo || e.hasOwnProperty('ativo'))]
                        ])
                      }), 128))
                    ], 512), [
                      [_vShow, (state.lst.length != 0)]
                    ]),
                    _createElementVNode("tbody", null, [
                      _withDirectives(_createElementVNode("tr", null, [
                        _hoisted_38,
                        _createElementVNode("td", null, _toDisplayString(state.textoAuxiliar), 1),
                        _hoisted_39
                      ], 512), [
                        [_vShow, (state.lst.length == 0) && state.carregando == false]
                      ])
                    ])
                  ])
                ], 4), [
                  [_vShow, state.carregando === false]
                ])
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  "data-bs-dismiss": "modal",
                  onClick: cancelar
                }, "Cancelar")
              ])
            ])
          ], 4)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_40, null, 512), [
      [_vShow, __props.visiblePesq]
    ]),
    (state.temErro)
      ? (_openBlock(), _createBlock(ModalMensagemDorape, {
          key: 1,
          title: state.tituloErro,
          visible: state.temErro,
          text: state.erro,
          onModalResult: modalErroResult
        }, null, 8, ["title", "visible", "text"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})